import React, { Fragment, useState, useEffect } from 'react'
import { Alert } from 'loyal-react'
import { Redirect } from 'react-router'

const SendMailToken = () => {
  const [ redirect, setRedirect ] = useState(false)
  const close = () => {
    setRedirect(true)
  }

  useEffect(() => {
    setInterval(() => {
      setRedirect(true)
    }, 10000)

    return () => {
      document.activeElement.blur()
    }
  })

  return (
    <Fragment>
      <div className='row mt-5 mt-md-0 mb-2'>
        <Alert
          isError={false}
          title='senha alterada com sucesso.'
          focusable='true'
          onClose={close}
        />
        { redirect && <Redirect to={'/security-access'} /> }
      </div>
    </Fragment>
  )
}

SendMailToken.propTypes = {}

export default SendMailToken



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/UnlockUraPassword/SucessUnlock/SucessUnlock.js